export default {
  'mrcdc.depositCheckView.pageHeader': 'Deposit Check',
  'mrcdc.depositCheckView.depositTo': 'Deposit To',
  'mrcdc.depositCheckView.depositToPlaceholder': 'Choose account to deposit into',
  'mrcdc.depositCheckView.amount': 'Amount',
  'mrcdc.depositCheckView.amountPlaceholder': 'Enter how much to deposit',
  'mrcdc.depositCheckView.batchIdNumber': 'Batch ID#',
  'mrcdc.depositCheckView.memo': 'Memo',
  'mrcdc.depositCheckView.memoPlaceholder': 'Enter comment here',
  'mrcdc.depositCheckView.checkPhotoHeading': 'Photograph your Check',
  'mrcdc.depositCheckView.frontOfCheckText': 'Front',
  'mrcdc.depositCheckView.backOfCheckText': 'Back',
  'mrcdc.depositCheckView.depositCheckButtonText': 'Deposit Check',
  'mrcdc.depositCheckView.depositAccountRequiredMessage': 'A deposit to account is required',
  'mrcdc.depositCheckView.amountRequiredMessage': 'A deposit amount is required',
  'mrcdc.depositCheckView.genericRequiredMessage': 'An entry for <%=name %> is required',
  'mrcdc.depositCheckView.checkPhotoRequiredMessage': 'image required',

  'mrdc.depositAccountsView.heading': 'Select <strong>Deposit To</strong> account',
  'mrcdc.depositHistoryView.pageHeader': 'Deposit History',

  'mrdc.depositSuccessView.heading': 'Submitted',
  'mrdc.depositSuccessView.messageLineOne': 'Your deposit has been submitted',
  'mrdc.depositSuccessView.messageLineTwo':
    'Funds are usually available within 3-5 business days.',
  'mrdc.depositSuccessView.messageLineThree':
    'Deposits made after 5PM, Weekends, or Holidays will be processed on the next business day.',
  'mrdc.depositSuccessView.depositAnother': 'Make Another Deposit',
  'mrdc.depositSuccessView.finished': 'Finished',

  'mrcdc.depositHistoryView.status': 'Status',
  'mrcdc.depositHistoryView.pending': 'Pending',
  'mrcdc.depositHistoryView.completed': 'Completed',
  'mrcdc.depositHistoryView.rejected': 'rejected',
  'mrdc.depositHistoryView.noData': 'No information to display',
  'mrdc.depositHistoryView.noDepositsLineOne': "It looks like you haven't made a deposit yet.",
  'mrdc.depositHistoryView.noDepositsLineTwo':
    'All deposits for the past 7 days will be displayed here.',
  'mrdc.depositHistoryView.additionalBtnText': 'Make a Deposit',
  'mrcdc.depositModal.done': 'Done',

  'mrcdc.depositSystemUnavailable.errorText': 'Error',

  'mrcdc.depositSystemUnavailable.messageLineOne': 'System is currently unavailable',
  'mrcdc.depositSystemUnavailable.messageLineTwo':
    'Please try later or contact your administrator',

  'mrcdc.depositLimitsUnavailable.messageLineOne': 'No Limits Available for Deposit.',
  'mrcdc.depositAccountsUnavailable.messageLineOne': 'No Accounts Available for Deposit.',

  'mrcdc.depositErrors.contactAdministratorText': 'Please contact your Administrator',

  'mrcdc.depositDetailView.pageHeader': 'Check Deposit Details',
  'mrcdc.depositDetailView.checkImage': 'Check Image',

  'MRDC.REQUIRED_DEVICE_MODEL':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_DEVICE_SYSTEM_VER':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_DEVICE_SYSTEM_NAME':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_APP_VERSION':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_DEVICE_ID':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_APP_BUNDLE_ID':
    'Your request cannot be processed. Please contact your administrator or customer service.',
  'MRDC.REQUIRED_DEVICE_INFO':
    'Your request cannot be processed. Please contact your administrator or customer service.'
};
